(() => {
  if (window.__nettProductBuybarInitialized) return;
  window.__nettProductBuybarInitialized = true;

  const states = new Map();
  let animationFrame;

  const getPrimaryAction = (root) =>
    root.querySelector('[data-nh-primary-cta]') || root.querySelector('.product-form__submit');

  const syncStandardButton = (state) => {
    if (!state.mobileSubmit || !state.primaryAction) return;

    const isDisabled =
      state.primaryAction.disabled || state.primaryAction.getAttribute('aria-disabled') === 'true';
    state.mobileSubmit.disabled = isDisabled;
    state.mobileSubmit.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');

    if (isDisabled) {
      const sourceLabel = state.primaryAction.textContent.trim();
      state.mobileSubmit.textContent = sourceLabel || 'Nicht verfügbar';
    } else {
      state.mobileSubmit.textContent = 'In den Warenkorb';
    }
  };

  const updateState = (state) => {
    if (!state.root.isConnected) {
      states.delete(state.root);
      return;
    }

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const purchaseRect = state.purchaseArea.getBoundingClientRect();
    const actionRect = state.primaryAction.getBoundingClientRect();
    const buybarHeight = state.buybar.offsetHeight || 72;
    const purchaseIsVisible = purchaseRect.top < window.innerHeight && purchaseRect.bottom > buybarHeight;
    const actionIsVisible = actionRect.top < window.innerHeight - buybarHeight && actionRect.bottom > 0;
    const shouldShow = isMobile && purchaseIsVisible && !actionIsVisible;

    state.buybar.classList.toggle('is-visible', shouldShow);
    state.buybar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    syncStandardButton(state);
  };

  const updateAll = () => {
    animationFrame = undefined;
    states.forEach(updateState);
  };

  const scheduleUpdate = () => {
    if (animationFrame) return;
    animationFrame = window.requestAnimationFrame(updateAll);
  };

  const setupProduct = (root) => {
    if (states.has(root)) return;

    const buybar = root.querySelector('[data-nh-mobile-buybar]');
    const purchaseArea = root.querySelector('[data-nh-product-purchase]');
    const primaryAction = getPrimaryAction(root);
    if (!buybar || !purchaseArea || !primaryAction) return;

    const mobileSubmit = buybar.querySelector('[data-nh-mobile-submit]');
    const state = { root, buybar, purchaseArea, primaryAction, mobileSubmit };
    states.set(root, state);

    if (mobileSubmit) {
      mobileSubmit.addEventListener('click', () => {
        syncStandardButton(state);
        if (!mobileSubmit.disabled) primaryAction.click();
      });

      const buttonObserver = new MutationObserver(() => {
        syncStandardButton(state);
        scheduleUpdate();
      });
      buttonObserver.observe(primaryAction, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
        childList: true,
        subtree: true,
      });
    }

    updateState(state);
  };

  const scanProducts = (scope = document) => {
    if (scope.matches?.('product-info.nett-product-page')) setupProduct(scope);
    scope.querySelectorAll?.('product-info.nett-product-page').forEach(setupProduct);
    scheduleUpdate();
  };

  const updateVariantContent = ({ sectionId, html } = {}) => {
    if (!sectionId || !html) return;

    ['NettProductFacts', 'NettProductDetailsCopy'].forEach((prefix) => {
      const id = `${prefix}-${sectionId}`;
      const source = html.getElementById(id);
      const destination = document.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
    });
  };

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  document.addEventListener('shopify:section:load', (event) => scanProducts(event.target));
  document.addEventListener('shopify:block:select', scheduleUpdate);

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      updateVariantContent(data);
      window.setTimeout(() => scanProducts(), 0);
    });
  }

  scanProducts();
})();
